import { SaveOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

const BtnSave = (props) => {
    const { t } = useTranslation();
    const onCancel = () => {
        props.goToStep(8);
    };

    return (
        <div className="flex space-x-4">
            <Button
                type="default"
                size="large"
                className="px-8"
                onClick={onCancel}
            >
                {t('common.Cancel')}
            </Button>
            <Button
                loading={props.loading}
                type="primary"
                size="large"
                htmlType="submit"
                className="px-8"
                icon={<SaveOutlined />}
            >
                {t('common.Save')}
            </Button>
        </div>
    );
};

export default BtnSave;
